// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y9-1";
export var printerIcon = "_y9-0";